"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShareCart_1 = require("./ShareCart");
exports.default = ShareCart_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/ShareCart/index.js
// module id = 791
// module chunks = 8